module.exports = __webpack_public_path__ + "img/DJI_0219-Edit.e6589cb9.png";